<button class="button-undecorated card-container" [ngClass]="{'loading' : loading(), selected: selected()}" (click)="onItemSelected()" [disabled]="!availableSizePrices().length">
    <div class="info-container">
        <div class="title-container">
            <span class="title">{{item().label}}</span>
        </div>
        @if(hasCalories()) {
            <p class="calories-text">{{hasCalories()}}</p>
        }
        @if(smallestNoticePeriod()){
            <span class="notice-period">{{smallestNoticePeriod()}}</span>
        }
        <div class="description-wrapper">
            <span class="description" #descriptionElement [ngClass]="{unavailable: !availableSizePrices().length}">{{ item().description }}</span>
        </div>
        @if(!availableSizePrices().length){
            <span class="unavailable-pill">{{'modals.special_item_editor.special_item.unavailable' | transloco}}</span>
        }
    </div>
    <div class="add-button-wrapper" [ngClass]="{'no-img': !itemImg()}">
        @if(itemImg() && itemImg()?.src && itemImg()?.name !== 'none'){
        <img class="image" [src]="itemImg()?.src" [alt]="itemImg()?.name" cwoImageFallback>
        }  @else if (itemImg()?.name === "none") {} @else {
             <img class="image-placeholder" [src]="'assets/icons/itemPlaceholder.svg' | deployUrl" [alt]="'special placeholder'"/>
        }
        @if (availableSizePrices().length) {
        <div class="add-container">
            <div class="add" [ngClass]="{selected: selected()}">
                <cwo-icon class="icon" [name]="selected() ? iconNameType.check : iconNameType.boldPlus" [ngClass]="{selected: selected()}"/>
            </div>
        </div>
        }
    </div>
</button>